
/**
 * Distance mappings for bunker tests
 */

export const getBunkerDistances = (testId: string): Record<string, string> => {
  // Vérifier si nous sommes dans le niveau 2
  const isLevel2 = window.location.pathname.includes('level2');
  
  if (isLevel2) {
    // Level 2 bunker tests
    if (testId === "bunker-court") {
      return {
        "D": "5m",
        "E": "8m",
        "F": "12m"
      };
    }
    
    if (testId === "bunker-long") {
      return {
        "D1": "15m",
        "E1": "20m"
      };
    }
  } else {
    // Level 3 bunker tests
    if (testId === "bunker-court" || testId === "bunker-court-level3") {
      return {
        "BunkerA": "3m",
        "BunkerB": "7m",
        "BunkerC": "10m"
      };
    }
    
    if (testId === "bunker-long" || testId === "bunker-long-level3") {
      return {
        "BunkerD": "25m"
      };
    }
  }

  return {};
};
